var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClients = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0031 8C12.0031 9.65685 10.6595 11 9.00214 11C7.34479 11 6.00124 9.65685 6.00124 8C6.00124 6.34315 7.34479 5 9.00214 5C10.6595 5 12.0031 6.34315 12.0031 8ZM16.5044 7C15.1233 7 14.0037 8.11929 14.0037 9.5C14.0037 10.8807 15.1233 12 16.5044 12C17.8855 12 19.0052 10.8807 19.0052 9.5C19.0052 8.11929 17.8855 7 16.5044 7ZM14.4538 14.66C13.9448 13.6408 12.9024 12.9978 11.763 13H6.24131C5.10186 12.9978 4.05945 13.6408 3.55049 14.66L2.11006 17.55C1.95404 17.8595 1.96947 18.2277 2.15083 18.5231C2.3322 18.8185 2.65363 18.999 3.00033 19H15.004C15.3507 18.999 15.6721 18.8185 15.8535 18.5231C16.0348 18.2277 16.0502 17.8595 15.8942 17.55L14.4538 14.66ZM20.9458 15.65L21.896 17.55C22.0521 17.8595 22.0366 18.2277 21.8553 18.5231C21.6739 18.8185 21.3525 18.999 21.0058 19H17.8348C18.1044 18.2319 18.0503 17.3874 17.6848 16.66L16.3544 14H18.2649C19.3986 13.9997 20.4356 14.638 20.9458 15.65Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clients.55d89818.svg";
export { ForwardRef as ReactComponent };